module.exports = __webpack_public_path__ + "img/logo.ac52e10d.svg";